function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-100",
  cx: 80,
  cy: 80,
  r: 80
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-300",
  x: 28,
  y: 44,
  width: 104,
  height: 116,
  rx: 4
}), /*#__PURE__*/React.createElement("filter", {
  x: "-23.1%",
  y: "-20.7%",
  width: "146.2%",
  height: "141.4%",
  filterUnits: "objectBoundingBox",
  id: "filter-4"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-5",
  x: 37,
  y: 66,
  width: 84,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 84,
  height: 8,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-7",
  x: 37,
  y: 78,
  width: 84,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 84,
  height: 8,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-9",
  x: 37,
  y: 90,
  width: 84,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-10",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 84,
  height: 8,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-9"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-11",
  x: 37,
  y: 102,
  width: 84,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-12",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 84,
  height: 8,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-11"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u21B3-v13a",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "transactions_v13a#1-(empty-table)",
  transform: "translate(-640.000000, -220.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(640.000000, 220.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-200",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-100"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#EBEFFF",
  xlinkHref: "#path-100"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-200)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-4)",
  xlinkHref: "#path-300"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-300"
}))), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle",
  stroke: "#5F668A",
  mask: "url(#mask-6)",
  strokeDasharray: 1,
  xlinkHref: "#path-5"
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-Copy",
  stroke: "#5F668A",
  mask: "url(#mask-8)",
  strokeDasharray: 1,
  xlinkHref: "#path-7"
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-Copy-2",
  stroke: "#5F668A",
  mask: "url(#mask-10)",
  strokeDasharray: 1,
  xlinkHref: "#path-9"
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-Copy-3",
  stroke: "#5F668A",
  mask: "url(#mask-12)",
  strokeDasharray: 1,
  xlinkHref: "#path-11"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#EBEFFF",
  x: 37,
  y: 56,
  width: 84,
  height: 6,
  rx: 2
}))));

function SvgEmptyTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty-table.250884a9.svg";
export { ForwardRef as ReactComponent };